import { useNavigate } from "react-router-dom";
import { Eye, X } from "lucide-react";
import { getViewTenant, clearViewTenant } from "@/lib/viewTenant";

export const ViewingBanner = () => {
  const nav = useNavigate();
  const view = getViewTenant();
  if (!view) return null;
  const exit = () => { clearViewTenant(); nav("/owner"); };
  return (
    <div className="sticky top-0 z-30 bg-amber-400 text-slate-950 px-4 md:px-8 py-2 flex items-center justify-between gap-3 text-sm" data-testid="viewing-banner">
      <span className="inline-flex items-center gap-2 font-medium"><Eye className="w-4 h-4" /> Viewing <b data-testid="viewing-carrier-name">{view.name}</b><span className="hidden sm:inline">— read-only, changes are blocked</span><span className="sm:hidden">(read-only)</span></span>
      <button onClick={exit} className="inline-flex items-center gap-1 rounded-full bg-slate-950 text-white px-3 py-1 text-xs font-semibold hover:bg-slate-800 transition-colors" data-testid="viewing-exit-btn"><X className="w-3.5 h-3.5" /> Back to owner console</button>
    </div>
  );
};
